$(document).ready(function () {
  function ColorSwatch() {
    $(document).on('click', '.custom-swatches-list .color-item', function () {
      const $swatchesList = $(this).closest('.custom-swatches-list');

      // Mark selected swatch
      $swatchesList.find('.color-item').removeClass('selected');
      $(this).addClass('selected');
    
      const $gridItem = $(this).closest('.grid__item');
    
      // Update .more-swatch-count on swatch click
      const selected_swatch_url = $(this).find('.color').attr('data-image-url');
      $gridItem.find('a.more-swatch-count').attr('href', selected_swatch_url);

      // product badge update
      const selected_pro_badge = $(this).find('.color').attr('data-pro-available-badge');
      const selected_pro_badge_bg_color = $(this).find('.color').attr('data-badge-bg-color');
      let $badge = $gridItem.find('.card__inner .card__content .card__badge span');
      // $gridItem.find('.card__inner .card__content .card__badge span').text(selected_pro_badge);

      // // product badge BG color update
      // const selected_pro_badge_bg_color = $(this).find('.color').attr('data-badge-bg-color');
      // $gridItem.find('.card__inner .card__content .card__badge span').removeClass(function(i, className) {
      //     return (className.match(/(^|\s)color-\S+/g) || []).join(' ');
      //   })
      //   .addClass(selected_pro_badge_bg_color);



      // If no <span> exists, create one
      if ($badge.length === 0) {
        $badge = $('<span></span>').appendTo(
          $gridItem.find('.card__inner .card__content .card__badge')
        );
      }

      if (selected_pro_badge && selected_pro_badge.trim() !== "") {
        // Update text
        $badge.text(selected_pro_badge);
        // Ensure "badge" class exists + update color class
        $badge.removeClass(function (i, className) {
          return (className.match(/(^|\s)color-\S+/g) || []).join(' ');
        }).addClass('badge ' + selected_pro_badge_bg_color);
      } else {
        // If empty/null → remove the span completely
        $badge.remove();
      }

      const selected_pro_custom_badge = $(this).find('.color').attr('data-custom-badge');
      const selected_pro_custom_tag = $(this).find('.color').attr('data-custom-tag');

      // Target the badge wrapper inside the related product card
      const badgeWrapper = $gridItem.find('.product-card-wrapper .product__badge_wrapper');

      // // Clear any existing badge and add the new one
      // badgeWrapper.html(selected_pro_custom_badge);

      badgeWrapper.empty(); // clear existing
      badgeWrapper.append(selected_pro_custom_badge);
      badgeWrapper.append(selected_pro_custom_tag);

      
      // $(this).siblings().removeClass('selected');
      $(this).closest('.custom-swatches-list').find('.color-item').removeClass('selected');
      $(this).addClass('selected');

      // const $gridItem = $(this).closest('.grid__item');
      
      const variantUrl = $(this).find('.color').attr('data-image-url');
      const $productvariantUrl = $gridItem.find('.card__media a');
      const $producttitleUrl = $gridItem.find('.card__heading a');

      $productvariantUrl.attr('href', variantUrl);
      $producttitleUrl.attr('href', variantUrl);

      // Update title on swatch click
      const selected_title = $(this).find('.color').attr('data-title');
      $producttitleUrl.text(selected_title);
      // console.log('selected_title',selected_title);
  
      const imageSource = $(this).find('.color').attr('data-image-source');
      const imageSource2 = $(this).find('.color').attr('data-image-source-2') || imageSource;
      const key = $(this).find('.color').attr('data-image-alt');

      // // Get price values from data attributes
      // const priceSale = $(this).find('.color').attr('data-price-sale');
      // const priceRegular = $(this).find('.color').attr('data-price-regular');

      // // Update prices in the DOM
      // if (priceSale && priceRegular) {
      //   $gridItem.find('.price-item--sale.price-item--last').text(priceSale);
      //   $gridItem.find('.price-item--regular').text(priceRegular);
      // }

      // Get price values from the selected color
      const priceSale = $(this).find('.color').attr('data-price-sale');
      const priceRegular = $(this).find('.color').attr('data-price-regular');

      // console.log('priceSale',priceSale);
      // console.log('priceRegular',priceRegular);

      // Update prices in the DOM
      const $priceContainer = $gridItem.find('.price__container');
      
      if (priceSale && priceRegular) {
          // Both sale and regular prices exist
          $priceContainer.find('.price__regular').hide();
          $priceContainer.find('.price__sale').show();

          $priceContainer.find('.price-item--sale').text(priceSale);
          $priceContainer.find('.price-item--regular').text(priceRegular);

          // Add sale class if needed
          $priceContainer.closest('.price').addClass('price--on-sale');
      } else if (priceRegular) {
          // Only regular price exists
          $priceContainer.find('.price__regular').show();
          $priceContainer.find('.price__sale').hide();

          // Remove price--on-sale class only if priceSale is empty
          if (!priceSale || priceSale === '' || priceSale === 'undefined') {
            $priceContainer.closest('.price').removeClass('price--on-sale');
          }
        
          $priceContainer.find('.price-item--regular').text(priceRegular);
      }
  
      // const $gridItem = $(this).closest('.grid__item');
      const isMobile = window.matchMedia("(max-width: 749px)").matches;
  
      // if (isMobile) {
      //   const $swiperContainer = $gridItem.find('.grid-pro-img-slider');
  
      //   $swiperContainer.find('a.swiper-slide').each(function () {
      //     const colorKey = $(this).data('img-color-key');
      //     if (colorKey && colorKey.includes(key)) {
      //       $(this).show();
      //     } else {
      //       $(this).hide();
      //     }
      //   });
  
      //   if ($swiperContainer.hasClass('swiper-initialized')) {
      //     const swiperInstance = $swiperContainer[0].swiper;
      //     swiperInstance.destroy(true, true);
      //   }
  
      //   new Swiper($swiperContainer.get(0), {
      //     slidesPerView: 1,
      //     spaceBetween: 0,
      //     centeredSlides: false,
      //     loop: false,
      //     nested: true,
      //     followFinger: true,
      //     mousewheel: {
      //       forceToAxis: true,
      //       sensitivity: 1,
      //     },
      //   });
  
      //   // Handle desktop variant (hiding/showing image anchors)
      //   const $cardContent = $(this).closest('.card__content');
      //   const $cardMedia = $cardContent.parent().find('.card__media');
  
      //   $cardMedia.find('a').each(function () {
      //     const values = $(this).data('img-color-key');
      //     if (values && values.includes(key)) {
      //       $(this).show();
      //     } else {
      //       $(this).hide();
      //     }
      //   });
  
      // } else {
      //   const $productImages = $gridItem.find('.card__media .media img');
      //   if ($productImages.length > 0) {
      //     $productImages.eq(0).attr('src', imageSource).attr('srcset', imageSource);
      //     if ($productImages.length > 1) {
      //       $productImages.eq(1).attr('src', imageSource2).attr('srcset', imageSource2);
      //     }
      //   }
      // }

      const $productImages = $gridItem.find('.card__media .media img');
      if ($productImages.length > 0) {
        $productImages.eq(0).attr('src', imageSource).attr('srcset', imageSource);
          if ($productImages.length > 1) {
            $productImages.eq(1).attr('src', imageSource2).attr('srcset', imageSource2);
          }
        }
    });
  
    // Ensure all handlers are registered before triggering the first click
    setTimeout(() => {
      $('.custom-swatches-list .color-item:first-child .color').trigger('click');
    }, 0);
  }
  
  ColorSwatch();

  // function GridColumnCount() {
  //   // show 2 items per row
  //   $(".grid-product-column .column-btn-3").addClass("active");
  
  //   $(".grid-product-column .column-btn-2 svg").click(function () {
  //     const $parent = $(this).closest(".column-btn-2");
  //     $parent.addClass("active").siblings().removeClass("active");
  //     $(".product-grid-container .collection .product-grid").addClass("column-2");
  //     $(".product-grid-container .collection .product-grid").removeClass("column-3");

  //     $(".product-grid-container .collection .product-grid .grid__item.column-3-grid").addClass("large-up-hide");
  //     $(".product-grid-container .collection .product-grid .grid__item.column-2-grid").removeClass("large-up-hide");
  //   });
  
  //   // show 3 items per row
  //   $(".grid-product-column .column-btn-3 svg").click(function () {
  //     const $parent = $(this).closest(".column-btn-3");
  //     $parent.addClass("active").siblings().removeClass("active");
  //     $(".product-grid-container .collection .product-grid").addClass("column-3");
  //     $(".product-grid-container .collection .product-grid").removeClass("column-2");

  //     $(".product-grid-container .collection .product-grid .grid__item.column-3-grid").removeClass("large-up-hide");
  //     $(".product-grid-container .collection .product-grid .grid__item.column-2-grid").addClass("large-up-hide");
  //   });
  // }
  
      //   function GridColumnCount() {
      //   const $grid = $(".product-grid-container .collection .product-grid");
      //   const $buttons = $(".grid-product-column .column-btn");
      //   const $btn2 = $(".grid-product-column .column-btn-2");
      //   const $btn3 = $(".grid-product-column .column-btn-3");
      //   const $btn4 = $(".grid-product-column .column-btn-4");

      //   // Default active: 4 Grid
      //   $btn4.addClass("active");
      //   $grid.removeClass("grid--2-col-desktop grid--3-col-desktop").addClass("grid--4-col-desktop");

      //   // Two Grid
      //   $btn2.find("svg").on("click", function () {
      //     $btn2.addClass("active").siblings().removeClass("active");
      //     $grid.removeClass("grid--3-col-desktop grid--4-col-desktop").addClass("grid--2-col-desktop");
      //   });

      //   // Three Grid
      //   $btn3.find("svg").on("click", function () {
      //     $btn3.addClass("active").siblings().removeClass("active");
      //     $grid.removeClass("grid--2-col-desktop grid--4-col-desktop").addClass("grid--3-col-desktop");
      //   });

      //   // Four Grid
      //   $btn4.find("svg").on("click", function () {
      //     $btn4.addClass("active").siblings().removeClass("active");
      //     $grid.removeClass("grid--2-col-desktop grid--3-col-desktop").addClass("grid--4-col-desktop");
      //   });

      //   function handleGridAutoSwitch() {
      //     const width = window.innerWidth;
      //     if (width <= 1180 && width >= 990) {
      //       $grid.removeClass("grid--2-col-desktop grid--4-col-desktop").addClass("grid--3-col-desktop");
      //       $btn3.addClass("active").siblings().removeClass("active");
      //       $btn4.hide();
      //     } else {
      //       $btn4.show();
      //     }
      //   }

      //   handleGridAutoSwitch();
      //   $(window).on("resize", handleGridAutoSwitch);
      // }

      function GridColumnCount() {
  const $grid = $(".product-grid-container .collection .product-grid");
  const $btn2 = $(".grid-product-column .column-btn-2");
  const $btn3 = $(".grid-product-column .column-btn-3");
  const $btn4 = $(".grid-product-column .column-btn-4");
  let manualChange = false; // Track if user clicked manually

  // Default: 4 columns active
  $btn4.addClass("active");
  $grid
    .removeClass("grid--2-col-desktop grid--3-col-desktop")
    .addClass("grid--4-col-desktop");

  // --- Manual Click Events ---
  $btn2.find("svg").on("click", function () {
    manualChange = true;
    $btn2.addClass("active").siblings().removeClass("active");
    $grid
      .removeClass("grid--3-col-desktop grid--4-col-desktop")
      .addClass("grid--2-col-desktop");
  });

  $btn3.find("svg").on("click", function () {
    manualChange = true;
    $btn3.addClass("active").siblings().removeClass("active");
    $grid
      .removeClass("grid--2-col-desktop grid--4-col-desktop")
      .addClass("grid--3-col-desktop");
  });

  $btn4.find("svg").on("click", function () {
    manualChange = true;
    $btn4.addClass("active").siblings().removeClass("active");
    $grid
      .removeClass("grid--2-col-desktop grid--3-col-desktop")
      .addClass("grid--4-col-desktop");
  });

  // --- Handle Resize ---
  function handleGridAutoSwitch() {
    const width = window.innerWidth;

    // Only auto-switch if user hasn’t manually changed layout recently
    if (!manualChange) {
      if (width < 1200) {
        // Auto 3-grid below 1200px
        $btn3.addClass("active").siblings().removeClass("active");
        $grid
          .removeClass("grid--2-col-desktop grid--4-col-desktop")
          .addClass("grid--3-col-desktop");
      } else {
        // Auto 4-grid above 1200px
        $btn4.addClass("active").siblings().removeClass("active");
        $grid
          .removeClass("grid--2-col-desktop grid--3-col-desktop")
          .addClass("grid--4-col-desktop");
      }
    }
  }

  // Initial load
  handleGridAutoSwitch();

  // When resizing, auto-switch between 3 and 4 grid
  $(window).on("resize", handleGridAutoSwitch);
}

  GridColumnCount();

  // function LodemoreButton() {
  //   var endlessScroll = new Ajaxinate({
  //     container: '#product-grid',
  //     pagination: '#Huratips-Pagination',
  //     method: 'click',
  //     offset: 1000
  //   });
  // }

  // LodemoreButton();

  function Readmore() {
    $('.moreless-button').click(function() {
      $('.moretext').slideToggle();
      if ($('.moreless-button').text() == "Read more") {
        $(this).text("Read less");
      } else {
        $(this).text("Read more");
      }
    });
  }

  Readmore();

  document.addEventListener('loadmore:button:click', function () {
    ColorSwatch();
    // GridColumnCount();
    // LodemoreButton();
    // Readmore();
  });

  document.addEventListener('filter:product:grid:updated', function () {
    ColorSwatch();
    GridColumnCount();
    // LodemoreButton();
    // Readmore();
  });

  document.addEventListener('related:product:grid:colorswatch:updated', function () {
    ColorSwatch();
  });
document.addEventListener('initSwiper', () => {
      ColorSwatch();
  });
  

// $(document).ready(function() {
  $(window).on('scroll', function() {
    // Get necessary elements
    let announc = document.querySelector('.announcement-bar-section');
    let header = document.querySelector('.section-header');
    let CollectionFilter = document.querySelector('.facets-container');

    // Calculate the total height of announcement and header
    if (announc && header && CollectionFilter) {
      let TotalHeight = announc.offsetHeight + header.offsetHeight;
      // console.log(TotalHeight, 'TotalHeight');

      // Set the position of the collection filter based on the calculated height
      CollectionFilter.style.top = TotalHeight + 'px';
    }
  });
// });

// $(document).ready(function(){
  function sortFilter(){
    $(".sort-select").mouseenter(function () {
      $(".sort-select .sort").addClass("active");
      $(".sort-select .filter-options").show();
      $(".sort-select .top-arrow-svg").show();
    });
  
    $(".sort-select").mouseleave(function () {
      $(".sort-select .sort").removeClass("active");
      $(".sort-select .filter-options").hide();
      $(".sort-select .top-arrow-svg").hide();
    });


  
    $(".sort-select .filter-options .filter-tag").click(function(){
      $(".sort-select .filter-options").css("display","none");
      $(".sort-select .top-arrow-svg").css("display","none");
    });
    
  }
  sortFilter(); 
  
  document.addEventListener("filter:product:grid:updated", function() {
    sortFilter();
    ColorSwatch();
    GridColumnCount();
    Readmore();
  });  
// });
});

// header menu two lines come hover effect
$(document).ready(function () {
  function updateNavRowClass() {
    const ul = document.querySelector('.list-menu--inline');
    if (!ul) return;

    const liItems = Array.from(ul.children);
    const rowMap = new Map(); // Store top positions and associated <li>s

    liItems.forEach(item => {
      // Clear previous row-two class
      item.classList.remove('row-two');
      const top = item.getBoundingClientRect().top;
      if (!rowMap.has(top)) rowMap.set(top, []);
      rowMap.get(top).push(item);
    });

    const rowTops = Array.from(rowMap.keys()).sort((a, b) => a - b);
    const rowCount = rowTops.length;

    // Add or remove class on <ul>
    if (rowCount > 1) {
      ul.classList.add('has-multiple-rows');
    } else {
      ul.classList.remove('has-multiple-rows');
    }

    // Add class 'row-two' to second row <li>s
    if (rowCount >= 2) {
      const secondRowTop = rowTops[1];
      const secondRowItems = rowMap.get(secondRowTop);
      secondRowItems.forEach(item => item.classList.add('row-two'));
    }
  }

  window.addEventListener('load', updateNavRowClass);
  window.addEventListener('resize', updateNavRowClass);
});

// Cart Drawer Recomended Section Js Start
function cartRecommend(){
    const recommended_swiper = document.querySelector('.cart__recommended_product .cart__recommended_product_slide');
  
  if (recommended_swiper) {
      new Swiper(recommended_swiper, {
        slidesPerView: 2.2,
        spaceBetween: 16,
        loop: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        followFinger: true,
        mousewheel: {
          forceToAxis: true,
          sensitivity: 2,
        },
    breakpoints: {
      750: {
        slidesPerView: 2.5,
        spaceBetween: 16,
        centeredSlides: false
      },
    }
      });
  }
}
cartRecommend();
document.addEventListener('initSwiper', cartRecommend);
document.addEventListener("product:variant:changed:hide:unavailable:variant", cartRecommend);

// Cart Drawer Recomended Section Js End


// // working code
function hideUnavailableVariants(autoSelect = false, isInit = false) {
  const variantMap = JSON.parse(document.getElementById('variant-map').textContent);
  const optionNames = ['Color', 'Top Size', 'Bottom Size', 'Fit', 'Size'];

  function getSelectedOptions() {
    const selected = {};
    optionNames.forEach((name) => {
      const input = document.querySelector(`[name="${name}"]:checked`);
      if (input) selected[name] = input.value;
    });
    return selected;
  }

  function updateAvailability() {
    const selected = getSelectedOptions();

    const selectableNames = optionNames.filter(name =>
      document.querySelectorAll(`[name="${name}"]`).length > 0
    );

    if (selectableNames.length < 2) return;

    const lastOption = selectableNames[selectableNames.length - 1];
    const inputs = document.querySelectorAll(`[name="${lastOption}"]`);
    const selectedValue = selected[lastOption];
    let firstAvailable = null;

    inputs.forEach(input => {
      const value = input.value;
      const keyParts = [];

      selectableNames.forEach(name => {
        const val = name === lastOption ? value : selected[name];
        keyParts.push(val || '');
      });

      const key = keyParts.join(' / ');
      const entry = variantMap[key];
      const label = document.querySelector(`label[for="${input.id}"]`);

      // Reset all
      input.disabled = false;
      input.classList.remove('disabled');
      if (label) {
        label.classList.remove('unavailable', 'sold-out');
        label.style.display = '';
        if (!isInit) label.style.pointerEvents = '';
      }

      // Unified handling for both page load & change
      if (!entry) {
        if (!isInit) {
          input.disabled = true;
          input.classList.add('disabled');
          if (label) {
            label.classList.add('unavailable');
            label.style.display = 'none';
          }
        }
      } else if (!entry.available) {
        // Sold-out variant
        input.disabled = false; // always allow selection
        input.classList.add('disabled'); // visually mark
        if (label) {
          label.classList.add('sold-out');
        }
      } else {
        // Available
        if (!firstAvailable) firstAvailable = input;
      }
    });

    // Auto-select fallback
    if (autoSelect && (!selectedValue || document.querySelector(`[name="${lastOption}"]:checked`)?.disabled)) {
      if (firstAvailable) {
        firstAvailable.checked = true;
        firstAvailable.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // document.dispatchEvent(new Event("product:color:variant:change:show:allavailable:variant"));
  }

  // On page load: prevent clicks on Bottom Size until first interaction
  if (isInit) {
    const bottomInputs = document.querySelectorAll(`[name="Bottom Size"]`);
    bottomInputs.forEach(input => {
      const label = document.querySelector(`label[for="${input.id}"]`);
      if (label) label.style.pointerEvents = 'none';
    });
  }

  // Add listeners
  optionNames.forEach((name) => {
    const inputs = document.querySelectorAll(`[name="${name}"]`);
    inputs.forEach(input => {
      input.addEventListener('change', () => {
        requestAnimationFrame(() => {
          hideUnavailableVariants(true, false);
        });
      });
    });
  });

  updateAvailability();
}

// DOM Ready
// document.addEventListener("DOMContentLoaded", () => {
//   hideUnavailableVariants(false, true);
//   document.addEventListener("product:variant:changed", () => hideUnavailableVariants(true, false));
//   // document.addEventListener("product:variant:changed:hide:unavailable:variant", () => hideUnavailableVariants(true, false));
//   document.addEventListener("product:variant:changed:hide:unavailable:variant", (e) => {
//     const isInit = e?.detail?.init === true;
//     hideUnavailableVariants(true, isInit);
//   });
// });


(function(){
  // Removing disable class on initial load
  document.addEventListener('DOMContentLoaded', removeDisabledFromSelected);
  document.addEventListener('product:page:loaded', removeDisabledFromSelected);

  // Toggling the unavailable element
  document.addEventListener('dispatch:onchange:input:event', toggleUnavailableOption);

  // Hide unavailable options
  function toggleUnavailableOption(e){
    const target = e?.target?.activeElement;
    const target_name = target.getAttribute('name');
    const targetFieldset = target?.closest('fieldset');
    const dataIndex = targetFieldset?.getAttribute('data-index');
    const selected_option_value = target?.value;
    const containers = hasTopBottomOptions();
    let target_container = null;
    let selected_container = null;
    let option_name = null;
    let targeted_option_property_name = null;
    let actual_option_property_name = null;
    // Get Shopify variant ID from URL params
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');
    let selected_variant = null;

    // Select variant update
    if(variantId){
      current_product_data?.variants?.forEach((variant) => {
        // console.log(variant, variantId);
        if(variantId == variant.id){
          selected_variant = variant;
        }
      });
    }
    
    // Checking if the product has both top and bottom
    if(containers?.hasBoth == false){
      return;
    }

    // console.log("data index", dataIndex);
    
    if(dataIndex && dataIndex == "2"){
      target_container = containers.bottom;
      selected_container = containers.top;
      // option_name = "top";
      targeted_option_property_name = 'option3';
      actual_option_property_name = 'option2'
    } 
    if(dataIndex && dataIndex == "3"){
      target_container = containers.top;
      selected_container = containers.bottom;
      // option_name = "bottom";
      targeted_option_property_name = 'option2';
      actual_option_property_name = 'option3'
    }

    // Hide container options
    // If top = bottom
    // If bottom = top
    if(target_container){
      target_container.querySelectorAll('input[type="radio"]').forEach((input) => input.classList.add('hide-unavailable'));

      // Removing the hide-unavailable class if the variant is exist
      current_product_data?.variants?.forEach((variant) => {
        if(variant[actual_option_property_name] == selected_option_value){
          target_el = target_container.querySelector(`input[type="radio"][value="${variant[targeted_option_property_name]}"]`);
          if(target_el){
            target_el.classList.remove('hide-unavailable');
          }

          // Add the disabled classes for the target container element (Sold Out) ~ For third option only
          if(actual_option_property_name == 'option3' && variant.available == false){
            target_el.classList.add('disabled');
          }
        }
      });

      // Remove the disabled class from the selected container
      selected_container.querySelectorAll(`input[type="radio"]`).forEach(input => {
        if (input.classList.contains('disabled')) {
          input.classList.remove('disabled');
        }
      });

      // Checking the selected target checkbox
      const target_checked_el = target_container.querySelector('input[type="radio"]:not(.hide-unavailable):checked');
      const first_ava_el = target_container.querySelector('input[type="radio"]:not(.hide-unavailable)');
      if(!target_checked_el && first_ava_el){
        first_ava_el.checked = true;
        first_ava_el.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // if(target_container) {
    //   target_container.style.pointerEvents = 'auto';
    // }
  }

  // Function to remove disabled class from selected top and bottom inputs
  function removeDisabledFromSelected() {
    const containers = hasTopBottomOptions();

    // Checking if the product has both top and bottom
    if(containers?.hasBoth == false){
      return;
    }
    
    const topInputs = containers.top.querySelectorAll('input[type="radio"]');
    const bottomInputs = containers.bottom.querySelectorAll('input[type="radio"]');
    
    topInputs.forEach(input => {
      if (input.classList.contains('disabled')) {
        input.classList.remove('disabled');
      }
    });
    
    bottomInputs.forEach(input => {
      if (input.classList.contains('disabled')) {
        input.classList.remove('disabled');
      }
    });

    // Disable user select for bottom container
    // containers.bottom.style.pointerEvents = 'none';
  }

  // Helper function to convert option name to handle
  function toHandle(str = ''){
    return str.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9\-]/g, '');
  }
  
  // To check the product has the both size variants
  function hasTopBottomOptions(){
    // const top_classes = ["Top Size"];
    // const bottom_classes = ["Bottom Size"];
    // let top = null;
    // let bottom = null;
    
    // top_classes.forEach((op_name) => {
    //   top = document.querySelector(`fieldset.option-${toHandle(op_name)}`);
    // });
    // bottom_classes.forEach((op_name) => {
    //   bottom = document.querySelector(`fieldset.option-${toHandle(op_name)}`);
    // });

    let top = null;
    let bottom = null

    const variant_selects = document.querySelector('variant-selects');
    if(variant_selects){
      const fieldsets = variant_selects.querySelectorAll('fieldset[data-index]');
      if(fieldsets && fieldsets.length == 3){
        top = fieldsets[fieldsets.length - 2];
        bottom = fieldsets[fieldsets.length - 1];
      }
    }

  // console.log(top, bottom);
    
    return {
      top : top,
      bottom : bottom,
      hasBoth : top && bottom ? true : false
    };
  }
})();

document.addEventListener('DOMContentLoaded', function () {
  
function showMatchSize(){
  let radioBtn = document.querySelectorAll('input[type="radio"]');
  radioBtn.forEach((radioInput) => {
    if (radioInput.checked) {
      const closest_fieldset = radioInput.closest('fieldset');
  
      if (!closest_fieldset) return;
  
      const hasConversion = closest_fieldset.querySelector('.size-international-conversions');
  
      if (hasConversion) {
        closest_fieldset.classList.add('show_matching_size');
      } else {
         closest_fieldset.classList.remove('show_matching_size');
      }
    }
  });
}
 
function sizeLabelUpdate(){
  document.querySelectorAll('variant-selects fieldset').forEach(fieldset => {
    const conversionsDisplay = fieldset.querySelector('legend .size-international-conversions');
    const current_txt = conversionsDisplay?.textContent.trim();
    let initial_available = null;
  
    const sizeLabels = fieldset.querySelectorAll('label');
  
    sizeLabels.forEach(label => {
      if (label.dataset.listenerBound === "true") return; 
      label.dataset.listenerBound = "true";
      
      label.addEventListener('mouseenter', (e) => {
        const closest_fieldset = e.target.closest('fieldset');
  
        const hoveredSize = Array.from(label.childNodes)
          .filter(node => node.nodeType === Node.TEXT_NODE)
          .map(node => node.textContent.trim())
          .join('');
  
        let matched = false;
  
        document.querySelectorAll('.size-entry').forEach(entry => {
          const sizeText = entry.querySelector('.size')?.textContent.trim();
          if (sizeText.toLowerCase() === hoveredSize.toLowerCase()) {
            const conversionsText = entry.querySelector('.conversions')?.textContent.trim();
            if (conversionsText && conversionsDisplay) {
              conversionsDisplay.textContent = conversionsText;
              matched = true;
            }
          }
        });
                
        if (
          closest_fieldset &&
          !closest_fieldset.classList.contains('show_matching_size')
        ) {
          initial_available = true;
          closest_fieldset.classList.add('show_matching_size');
        }

        if (!matched && conversionsDisplay) {
          conversionsDisplay.textContent = '';
        }
      });
  
      label.addEventListener('mouseleave', (e) => {
        const closest_fieldset = e.target.closest('fieldset');
        if (conversionsDisplay) {
          conversionsDisplay.textContent = initial_available ? '' : current_txt || '';
        }

        if (
          closest_fieldset &&
          closest_fieldset.classList.contains('show_matching_size') &&
          (!current_txt || current_txt == '')
        ){
          closest_fieldset.classList.remove('show_matching_size');
        }
      });
    });
  });
  showMatchSize();
}
  sizeLabelUpdate();
  document.addEventListener("product:variant:changed", sizeLabelUpdate);
  document.addEventListener("product:variant:changed:hide:unavailable:variant", sizeLabelUpdate);
});


// cart drawer free shipping bar for Rest of world
document.addEventListener('DOMContentLoaded', function () {
  function FreeShippingCartDrawer(cartTotalRaw = null) {
    const drawer = document.querySelector('cart-drawer') || document;
    const shippingBar = drawer.querySelector('#shipping-bar');
    if (!shippingBar) return;

    const baseAmount = parseFloat(shippingBar.dataset.base);
    const currencyCode = (Shopify?.currency?.active || shippingBar.dataset.currency || 'AUD').toUpperCase();
    let rate = parseFloat(Shopify?.currency?.rate || 1.0);
    if (isNaN(baseAmount)) return;
    if (isNaN(rate)) rate = 1.0;

    const convertedBase = baseAmount * rate;
    let cartTotal = cartTotalRaw ? cartTotalRaw : 0;

    // ✅ Format number to localized currency using browser locale and Shopify's currency
    function formatCurrency(amount, currency) {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency,
        currencyDisplay: 'symbol',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(amount);
    }

    function updateUI() {
      const shippingValueLeftRaw = Math.max(0, convertedBase - cartTotal);
      const shippingProgress = Math.min(100, (cartTotal / convertedBase) * 100).toFixed(1);
    
      const shippingText = shippingBar.querySelector('.shipping-text');
      const progressBar = shippingBar.querySelector('.progressbar span');
      const defaultMsg = shippingBar.querySelector('.shipping-message');
      const successMsg = shippingBar.querySelector('.free-shipping-message');
    
      const taxNote = drawer.querySelector('.tax-note.caption-large');
      const freeShippingContent = drawer.querySelector('.free-shipping-content');
    
      if (cartTotal >= convertedBase) {
        if (defaultMsg) defaultMsg.style.display = 'none';
        if (successMsg) successMsg.style.display = 'block';
        if (taxNote) taxNote.style.display = 'none';
        if (freeShippingContent) freeShippingContent.style.display = 'flex';
      } else {
        if (defaultMsg) defaultMsg.style.display = 'flex';
        if (successMsg) successMsg.style.display = 'none';
        if (shippingText) {
          shippingText.textContent = `${formatCurrency(shippingValueLeftRaw, currencyCode)} away`;
        }
        if (taxNote) taxNote.style.display = 'block';
        if (freeShippingContent) freeShippingContent.style.display = 'none';
      }
    
      if (progressBar) {
        progressBar.style.width = `${shippingProgress}%`;
      }
    
      // ✅ Reveal the bar only after JS has updated content
      shippingBar.style.visibility = 'visible';
    }


    if (cartTotalRaw !== null) {
      cartTotal = cartTotalRaw;
      updateUI();
    } else {
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          cartTotal = cart.total_price / 100;
          updateUI();
        });
    }
  }

  FreeShippingCartDrawer();

  document.addEventListener('cart:updated', (e) => {
    if (e.detail && e.detail.cart) {
      const cartTotal = e.detail.cart.total_price / 100;
      FreeShippingCartDrawer(cartTotal);
    } else {
      FreeShippingCartDrawer();
    }
  });

  const drawer = document.querySelector('cart-drawer');
  if (drawer) {
    const observer = new MutationObserver(() => {
      FreeShippingCartDrawer();
    });
    observer.observe(drawer, { childList: true, subtree: true });
  }
});


document.addEventListener('DOMContentLoaded', function() {     
  class cartVariantSelects extends HTMLElement {
    constructor() {
      super();
      this.matchedVariant = null;
      this.atcButton = this.querySelector('[data-atc-button]');
      this.optionSelectors = Array.from(this.querySelectorAll("[data-option-selector]"));
      this.productHandle = this.dataset.productHandle;
    }

    connectedCallback() {
      this.addEventListener('change', (event) => {
        const target = this.getInputForEventTarget(event.target);
        this.updateSelectionMetadata(event);

        // New: Run variant matching logic when radio button changes
        if (target.tagName === 'INPUT' && target.type === 'radio') {
          this.matchSelectedVariant();
        }

        publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
          data: {
            event,
            target,
            selectedOptionValues: this.selectedOptionValues,
          },
        });
      });

      // Handle Add to Cart button
      if (this.atcButton) {
        this.atcButton.addEventListener('click', (e) => {
          e.preventDefault();
          let variant_id = this.atcButton.dataset.variantId;
          if (!variant_id) {
            alert('Please select all options before adding to cart.');
            return;
          }
          this.addToCart(variant_id, 1);
          
        });
      }
    }

    matchSelectedVariant() {
      const productData = this.querySelector('[type="application/json"][data-product-json]');

      if (!productData) return;
      this.productObject = JSON.parse(productData.textContent);
      this.productObject['product']['options'] = this.productObject.options_with_values;
      // Collect all selected radio button values for this product
      let selectedOptions = Array.from(
        this.querySelectorAll('.product-form__input input[type="radio"]:checked')
      ).map((el) => el.value);

      let selectedOptionsObj = {
        option1: selectedOptions[0] || null,
        option2: selectedOptions[1] || null,
        option3: selectedOptions[2] || null
      };

      // Find the variant matching the selected options
      let matchedVariant = this.productObject['product'].variants.find((variant) => {
        return JSON.stringify(selectedOptions) === JSON.stringify(variant.options);
      });

      if (matchedVariant) {
        // console.log("Matched Variant:", matchedVariant);
        // console.log("this.productObject:", this.productObject);
        this.matchedVariant = matchedVariant;
        this.atcButton.dataset.variantId = matchedVariant.id;

        //  console.log(matchedVariant, "matchedVariant")
          this.getCardInformationSibling(matchedVariant, this.productObject['product']);
          this.soldoutToggle(this.productObject, this.matchedVariant);
          
        // You can store, publish, or update UI here
          if (this.atcButton) {
          if(this.matchedVariant.available){
              this.atcButton.textContent = window.variantStrings['addToCart'];
              this.atcButton.disabled = false;
          }else{
              this.atcButton.textContent = window.variantStrings['soldOut'];
              this.atcButton.disabled = true;
          }
          }
      }else{
          this.atcButton.textContent = window.variantStrings['unavailable'];
          this.atcButton.disabled = true;
          selectedOptionsObj.is_available = false;
          this.soldoutToggle(this.productObject, selectedOptionsObj);
      }
    }

    soldoutToggle(productObj, matchedVariant) {
        if (!productObj['product']?.variants || !matchedVariant) return;
        // console.log(productObj['product'], "productObj['product']")
        const applyClassToSelector = (selector, valueIndex, available, hasAtLeastOneCombination) => {

            const optionValue = Array.from(selector.querySelectorAll("[data-option-value]"))[valueIndex];
            optionValue.toggleAttribute("hidden", !hasAtLeastOneCombination);
            if (this.hideSoldOutVariants) {
              optionValue.toggleAttribute("hidden", !available);
            } else {
              optionValue.classList.toggle("disabled", !available);
            }
        };
        if (this.optionSelectors && this.optionSelectors[0]) {
      
          productObj['product']["options"][0]["values"].forEach((value, valueIndex) => {
            const hasAtLeastOneCombination = productObj['product']["variants"].some((variant) => variant["option1"] === value && variant), hasAvailableVariant = productObj['product']["variants"].some((variant) => variant["option1"] === value && variant["available"]);
            applyClassToSelector(this.optionSelectors[0], valueIndex, hasAvailableVariant, hasAtLeastOneCombination);
            if (this.optionSelectors[1]) {
              productObj['product']["options"][1]["values"].forEach((value2, valueIndex2) => {
                const hasAtLeastOneCombination2 = productObj['product']["variants"].some((variant) => variant["option2"] === value2 && variant["option1"] === matchedVariant["option1"] && variant), hasAvailableVariant2 = productObj['product']["variants"].some((variant) => variant["option2"] === value2 && variant["option1"] === matchedVariant["option1"] && variant["available"]);
                applyClassToSelector(this.optionSelectors[1], valueIndex2, hasAvailableVariant2, hasAtLeastOneCombination2);
                if (this.optionSelectors[2]) {
                  productObj['product']["options"][2]["values"].forEach((value3, valueIndex3) => {
                    const hasAtLeastOneCombination3 = productObj['product']["variants"].some((variant) => variant["option3"] === value3 && variant["option1"] === matchedVariant["option1"] && variant["option2"] === matchedVariant["option2"] && variant), hasAvailableVariant3 = productObj['product']["variants"].some((variant) => variant["option3"] === value3 && variant["option1"] === matchedVariant["option1"] && variant["option2"] === matchedVariant["option2"] && variant["available"]);
                    applyClassToSelector(this.optionSelectors[2], valueIndex3, hasAvailableVariant3, hasAtLeastOneCombination3);
                  });
                }
              });
            }
          });
        }
    }

    async addToCart(variantId, quantity) {
      try {
        const updateProOnCart = document.querySelector('cart-drawer');
        const sections = updateProOnCart.getSectionsToRender().map((section) => section.id);
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            "id": variantId,
            "quantity": quantity,
            'sections': sections 
          })
        });

        if (!res.ok) throw new Error('Failed to add to cart');
        const data = await res.json();
        // console.log('Added to cart:', data);
        updateProOnCart.renderContents(data);
      } catch (err) {
        console.error(err);
      }
    }

    formatPriceAmount(cents) {
        const amount = cents / 100;
        const currencyCode = window.Shopify.currency.active;
        const locale = navigator.language || 'en-US';

        let options = {
          style: 'currency',
          currency: currencyCode,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        };

        // Special case: USD remove trailing zeros
        if (currencyCode === 'USD') {
          options.minimumFractionDigits = 0;
        }

        return new Intl.NumberFormat(locale, options).format(amount);
    }

    async fetchPrice(url, selector, matchVariant, salePrice, mrp, withoutMrp, priceWrapper) {
        try {
          const response = await fetch(url);
          if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

          const html = await response.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          const priceElement = doc.querySelector(selector);
          const wrapperPrice = priceWrapper.querySelector('.card__content .price__container');

          if (priceElement && wrapperPrice) {
            // console.log('Fetched Price:', priceElement);
            // console.log(priceWrapper, "priceWrapper");
            
            // Replace the old element with the new one
            wrapperPrice.replaceWith(priceElement);

            return priceElement;
          } else {
            throw new Error('Price element not found');
          }


        } catch (error) {
          console.error('Error fetching price:', error);

          // Fallback: Use matchVariant data
          if (matchVariant.compare_at_price) {
            // console.log("MRP");
            salePrice.textContent = this.formatPriceAmount(matchVariant.price);
            mrp.textContent = this.formatPriceAmount(matchVariant.compare_at_price);
            priceWrapper.classList.add('price--on-sale');
          } else {
            withoutMrp.textContent = this.formatPriceAmount(matchVariant.price);
            priceWrapper.classList.remove('price--on-sale');
            // console.log("No MRP");
          }
        }
    }


    getCardInformationSibling(matchVariant, productObject) {
      const cardWrapper = this.closest('.card-wrapper');

    if (!cardWrapper) return;

      const priceWrapper = cardWrapper?.querySelector('.card__information .price');
      const salePrice = cardWrapper?.querySelector('.card__information .price__sale .price-item--sale');
      const mrp = cardWrapper?.querySelector('.card__information .price__sale .price-item--regular');
      const withoutMrp = cardWrapper?.querySelector('.card__information .price__regular .price-item--regular');
      
      const proHandle = `${window.shopUrl}/products/${this.productHandle}?variant=${matchVariant.id}`;
      this.fetchPrice(
        proHandle,
        '.product__info-container .price .price__container',
        matchVariant,
        salePrice,
        mrp,
        withoutMrp,
        priceWrapper
      );

    // --- Feature image updates ---
      const cardMediaImg = cardWrapper.querySelector('.card__media img');

      if (cardMediaImg) {
        // Use variant image if available, else fall back to product image
        const imageData = matchVariant.featured_image || productObject.featured_image;

        if (imageData?.src) {
          const imgBase = imageData.src.split('?')[0];
          const altText = imageData.alt || '';

          const srcset = [
            `${imgBase}?width=165 165w`,
            `${imgBase}?width=360 360w`,
            `${imgBase}?width=533 533w`,
            `${imgBase}?width=720 720w`,
            `${imgBase} 860w`
          ].join(', ');

          const existingSizes = cardMediaImg.getAttribute('sizes') || 
            '(min-width: 1440px) 327px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)';

          cardMediaImg.src = `${imgBase}?width=533`;
          cardMediaImg.srcset = srcset;
          cardMediaImg.setAttribute('sizes', existingSizes);
          cardMediaImg.alt = altText;
        }
      }
    }

    updateSelectionMetadata({ target }) {
      const { value, tagName } = target;

      if (tagName === 'SELECT' && target.selectedOptions.length) {
        Array.from(target.options)
          .find((option) => option.getAttribute('selected'))
          .removeAttribute('selected');
        target.selectedOptions[0].setAttribute('selected', 'selected');

        const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
        const selectedDropdownSwatchValue = target
          .closest('.product-form__input')
          .querySelector('[data-selected-value] > .swatch');
        if (!selectedDropdownSwatchValue) return;
        if (swatchValue) {
          selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
          selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
        } else {
          selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
          selectedDropdownSwatchValue.classList.add('swatch--unavailable');
        }

        selectedDropdownSwatchValue.style.setProperty(
          '--swatch-focal-point',
          target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
        );
      } else if (tagName === 'INPUT' && target.type === 'radio') {
        const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
        if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
      }
    }

    getInputForEventTarget(target) {
      return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
    }

    get selectedOptionValues() {
      return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
        ({ dataset }) => dataset.optionValueId
      );
    }
  }

  customElements.define('cart-variant-picker', cartVariantSelects);

function cartDrawerInterlinkAtc(){
      const swatches = document.querySelectorAll('.drawer .cart-drawer .cart__recommended_product .color-item span');
      const atcBtn = document.querySelector('.atc-btn');

      swatches.forEach(swatch => {
        swatch.addEventListener('click', function () {
          const url = this.getAttribute('data-image-url');
          if (url && atcBtn) {
            atcBtn.setAttribute('href', url);
          }
        });
      });
  }
  cartDrawerInterlinkAtc();
  document.addEventListener("product:variant:changed:hide:unavailable:variant", cartDrawerInterlinkAtc);
})



document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    const shadowHost = document.querySelector('#search-bar-root');
    const shadowRoot = shadowHost?.shadowRoot;
    const style = document.createElement('style');
    style.textContent = `
      .fixed.bottom-6{
        bottom: 95px !important;
        left: auto;
        right: 22px !important;
        transform: unset !important;
        z-index: 100 !important;
      }
      @media screen and (max-width: 749px){
         .fixed.bottom-6{
             bottom: 100px !important;
          }
      }
    `;
    shadowRoot?.appendChild(style);
  }, 8000)
})


document.addEventListener('DOMContentLoaded', () => {
    function topThreeBarPosition(){
        const top_bar_scroll = document.querySelector('.scroll-animation-section');
        const announcement_bar = document.querySelector('.announcement-bar-section');
        const header = document.querySelector('.shopify-section-header-sticky');
        const hamburger_menu = document.querySelector('header header-drawer #menu-drawer');
        const product_column_sticky = document.querySelector('section.product__info-container.product__column-sticky');

        const collectz_filter = document.querySelector(".facets-vertical aside")
        const search_model = document.querySelector(".custom-header__search .custom-search-modal .search-modal__form .search-modal__form")

        let lastTopBarHeight = 0;
        let lastAnnouncementHeight = 0;
        let lastHeaderHeight = 0;

        // --- Top Bar ---
        const is_top_bar_available = !!top_bar_scroll;
        const is_tb_sticky = is_top_bar_available
          ? !!top_bar_scroll.querySelector('.scroll__animation_sticky_enabled')
          : false;
        const top_bar_height = is_top_bar_available ? top_bar_scroll.offsetHeight : 0;

        // --- Announcement Bar ---
        const is_announcement_bar_available = !!announcement_bar;
        const is_announce_sticky = is_announcement_bar_available
          ? !!announcement_bar.querySelector('.announcement_sticky')
          : false;
        const announcement_bar_height = is_announcement_bar_available ? announcement_bar.offsetHeight : 0;

        // --- Header ---
        const is_header_available = !!header;
        const is_header_sticky = is_header_available
          ? !!header.querySelector('.header_sticky_available')
          : false;
        const header_height = is_header_available ? header.offsetHeight : 0;

        function initial_positions(){
          if(is_top_bar_available && is_announcement_bar_available && is_header_available){
            top_bar_scroll.style.top = `0px`;
            announcement_bar.style.top = `${top_bar_height}px`;
            header.style.top = `${top_bar_height + announcement_bar_height}px`;
            announcement_bar.classList.add('announcement_fixed_cls');
            hamburger_menu.style.top = `-${top_bar_height + announcement_bar_height}px`;
          }else if(!is_top_bar_available && is_announcement_bar_available && is_header_available){
            announcement_bar.style.top = `0px`;
            header.style.top = `${announcement_bar_height}px`;
            announcement_bar.classList.add('announcement_fixed_cls');
            hamburger_menu.style.top = `-${announcement_bar_height}px`;
          }else if(is_top_bar_available && !is_announcement_bar_available && is_header_available){
            top_bar_scroll.style.top = `0px`;
            header.style.top = `${top_bar_height}px`;
            hamburger_menu.style.top = `-${top_bar_height}px`;
            
          }else if(!is_top_bar_available && !is_announcement_bar_available && is_header_available){
            header.style.top = `0px`;
            hamburger_menu.style.top = `-${0}px`;
          }
        }
        initial_positions();
        
        // --- Scroll Event Handler ---
        document.addEventListener('scroll', () => {
          const scrollTop = window.scrollY || document.documentElement.scrollTop;
          const top_bar_height = top_bar_scroll?.offsetHeight || 0;
          const announcement_bar_height = announcement_bar?.offsetHeight || 0;
          const header_height = header?.offsetHeight || 0;
          
          const rawTopBarHeight = top_bar_scroll?.offsetHeight || 0;
          const rawAnnouncementHeight = announcement_bar?.offsetHeight || 0;
          const rawHeaderHeight = header?.offsetHeight || 0;

          // cache last non-zero heights
          if (rawTopBarHeight > 0) lastTopBarHeight = rawTopBarHeight;
          if (rawAnnouncementHeight > 0) lastAnnouncementHeight = rawAnnouncementHeight;
          if (rawHeaderHeight > 0) lastHeaderHeight = rawHeaderHeight;

          const finalTopBarHeight = rawTopBarHeight || lastTopBarHeight;
          const finalAnnouncementHeight = rawAnnouncementHeight || lastAnnouncementHeight;
          const finalHeaderHeight = rawHeaderHeight || lastHeaderHeight;

          const totalHeight =
            finalTopBarHeight + finalAnnouncementHeight + finalHeaderHeight;

          if (scrollTop === 0) {
            // When user scrolls to the top, restore initial layout
            initial_positions();
            console.log("Back to top — initial positions restored");

            if (collectz_filter) {
              search_model.style.padding = `0 2rem 16px`;
              collectz_filter.style.padding = `0`;
            }
            
            return;
          }
          // Otherwise, handle sticky logic
          if (is_tb_sticky && is_announce_sticky && is_header_sticky) {

            top_bar_scroll.style.top = "0px";
            announcement_bar.style.top = `${top_bar_height}px`;
            header.style.top = `${top_bar_height + announcement_bar_height}px`;
            hamburger_menu.style.top = `-${top_bar_height + announcement_bar_height}px`;
            if(product_column_sticky){
               product_column_sticky.style.top = `${top_bar_height + announcement_bar_height + header_height}px`;
            }

            if (collectz_filter) {
              collectz_filter.style.top = `${top_bar_height + announcement_bar_height + header_height}px`;
              search_model.style.padding = `0 2rem 8px`;
              collectz_filter.style.padding = `0 0 6px`;
            }

          } else if (!is_tb_sticky && is_announce_sticky && is_header_sticky) {
            announcement_bar.style.top = `0px`;
            header.style.top = `${announcement_bar_height}px`;
            hamburger_menu.style.top = `-${announcement_bar_height}px`;
            if(product_column_sticky){
              product_column_sticky.style.top = `${announcement_bar_height + header_height}px`;
            }
            
            if (collectz_filter) {
              collectz_filter.style.top = `${announcement_bar_height + header_height}px`;
              search_model.style.padding = `0 2rem 8px`;
              collectz_filter.style.padding = `0 0 6px`;
            }

          }else if(is_tb_sticky && !is_announce_sticky && is_header_sticky){

            top_bar_scroll.style.top = `${0}px`;
            header.style.top = `${top_bar_height}px`;
            if(announcement_bar){
              announcement_bar.classList.add('announcement_fixed_cls');
            }
            hamburger_menu.style.top = `-${top_bar_height}px`;
            if(product_column_sticky){
              product_column_sticky.style.top = `${top_bar_height + header_height}px`;
            }
            
            if (collectz_filter) {
              collectz_filter.style.top = `${top_bar_height + header_height}px`;
              search_model.style.padding = `0 2rem 8px`;
              collectz_filter.style.padding = `0 0 6px`;
            }
            
          }else if(!is_tb_sticky && !is_announce_sticky && is_header_sticky){

            header.style.top = `${0}px`;
            if(announcement_bar){
              announcement_bar.classList.remove('announcement_fixed_cls');
            }
            hamburger_menu.style.top = `-${0}px`;
          if(product_column_sticky){
            product_column_sticky.style.top = `${header_height}px`;
          }
            
            if (collectz_filter) {
              collectz_filter.style.top = `${header_height}px`;
              search_model.style.padding = `0 2rem 8px`;
              collectz_filter.style.padding = `0 0 6px`;
            }
          }
          else {
            if (collectz_filter) {
              collectz_filter.style.top = `0px`;
              collectz_filter.style.padding = `5px 0 5px`;
            }
          }
        })
    }
    topThreeBarPosition();


    function judgmeReview(){
        const badge = document.querySelector('.jdgm-prev-badge');
        const target = document.querySelector('.jdgm-review-widget');
        if (badge && target) {
          badge.addEventListener('click', function(e) {
            e.preventDefault();
            target.scrollIntoView({ behavior: 'smooth' });
          });
        }
    }

    judgmeReview();

    document.addEventListener("ajaxloader:render", function () {
        topThreeBarPosition();
        judgmeReview();
    });

});
